import classNames from 'classnames';

import styles from './Dimmer.module.scss';
import { DimmerProps } from './Dimmer.types';

export function Dimmer({
  mod = 'dark',
  opaque = false,
  className,
  children,
  ...rest
}: DimmerProps) {
  return (
    <div
      className={classNames(
        styles.dimmer,
        styles[mod],
        opaque && styles.opaque,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
